<template>
  <v-autocomplete
      multiple
      :class="{'loading' : loading}"
      :disabled="disabled"
      :label="false"
      :clear-on-select="false"
      :placeholder="infoSelect.placeholder"
      v-model="editableSelect"
      v-model:search="searchAcc"
      @update:focused="focusSelect"
      class="auto-complete-container"
      label="Autocomplete"
      :items="items"
  >
  </v-autocomplete>
</template>

<script>
import IconArrow from "@/components/shared/icons/IconArrow.vue";

export default {
  name: "AutocompleteMultiple",
  components: {IconArrow},
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    value: {
      default: []
    },
    infoSelect: {
      type: Object,
      default: () => {
        return {
          key: 'select',
          placeholder: 'Select'
        }
      }
    },
    items: {
      type: Array,
      required: true,
      default: () => {
        return [
          {
            title: 'default name',
            value: 'default value'
          }
        ]
      }
    }
  },
  data() {
    return {
      editableSelect: [],
      focusParam: false,
      searchAcc: ''
    }
  },
  mounted() {
    if(this.value !== '' && this.value !== undefined) {
      this.loadMounted = true;
      this.editableSelect = this.value
      this.$nextTick(() => {
        this.loadMounted = false
      })
    }
  },
  watch: {
    value() {
      this.loadMounted = true;
      this.editableSelect = this.value
      this.$nextTick(() => {
        this.loadMounted = false
      })
    },
    searchAcc() {
      if(!this.loadMounted) {
        this.$emit('changeValueSearch', this.searchAcc)
      }
    },
    editableSelect() {
      if(!this.loadMounted) {
        this.$emit('changeValue', {
          value: this.editableSelect,
          key: this.infoSelect.key
        })
      }
    }
  },
  methods: {
    focusSelect(state) {
      this.focusParam = state
      if(state) {
        this.$emit('loadItems')
      }
    }
  }
}
</script>

<style scoped>
</style>